// lib/supabase.js — Client Supabase

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = 'https://hxwvflxlxeevfdmufvzv.supabase.co';
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh4d3ZmbHhseGVldmZkbXVmdnp2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk0ODE0MjUsImV4cCI6MjA5NTA1NzQyNX0.GbF0G7TeU-eV31m8JStfKWY3dV0PYrmwFVn1vn-MfOE';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);

export const signUp  = (email, password) => supabase.auth.signUp({ email, password });
export const signIn  = (email, password) => supabase.auth.signInWithPassword({ email, password });
export const signOut = () => supabase.auth.signOut();
export const getUser = () => supabase.auth.getUser();

export const submitEvent = async (eventData, user) =>
  supabase.from('events_users').insert([{
    ...eventData,
    user_id:    user.id,
    user_email: user.email,
    status:     'pending',
  }]);

export const getApprovedEvents = async () => {
  const { data, error } = await supabase
    .from('events_users').select('*').eq('status', 'approved').order('year');
  return { data: data || [], error };
};

export const getUserEvents = async (userId) => {
  const { data, error } = await supabase
    .from('events_users').select('*').eq('user_id', userId).order('created_at', { ascending: false });
  return { data: data || [], error };
};

export const getPendingEvents = async () => {
  const { data, error } = await supabase
    .from('events_users').select('*').eq('status', 'pending').order('created_at', { ascending: false });
  return { data: data || [], error };
};

export const updateEventStatus = async (id, status) =>
  supabase.from('events_users').update({ status }).eq('id', id);
